import {Component, OnInit} from '@angular/core';
import {ComponentHelper, FormBaseComponent, ValidatorService} from '@utils-lib';
import {AppNameEnum, ArtAufteilungEnumLabels, GewinnermittlungAngaben, GewinnermittlungsartEnumLabels} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'common-ui-gewinnermittlung',
    templateUrl: './gewinnermittlung.component.html'
})
export class GewinnermittlungComponent extends FormBaseComponent<GewinnermittlungAngaben> implements OnInit {

    public gewinnermittlungsartEnum = GewinnermittlungsartEnumLabels;
    public artAufteilungEnum = ArtAufteilungEnumLabels;
    public showArtAufteilung = false;

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                protected readonly messageService: DatevMessageService,
                protected readonly translateService: TranslateService,
                protected readonly activatedRoute: ActivatedRoute) {
        super(messageService);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
        if (appEnum === AppNameEnum.FragebogenPersG) {
            this.showArtAufteilung = true;
        }
    }

    public onAbweichendesWirtschaftsJahrChanged(): void {
      if(!this.data.abweichendesWirtschaftsjahr) {
        this.form.get('beginnAbweichendesWirtschaftsjahr').setValue(null);
      }
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            gewinnermittlungsart: [this.data.gewinnermittlungsart,
                [
                    this.validatorService.required()
                ]],
            erlaeuterungSonstigeGewinnermittlungsart: [this.data.erlaeuterungSonstigeGewinnermittlungsart,
                [
                    this.validatorService.maxLength(120)
                ]],
            abweichendesWirtschaftsjahr: [this.data.abweichendesWirtschaftsjahr, []],
            beginnAbweichendesWirtschaftsjahr: [this.data.beginnAbweichendesWirtschaftsjahr, [
                this.validatorService.required(),
                this.validatorService.date(),
                this.validatorService.pattern('^(?!(01)\\.?(01)).*$',
                    this.translateService.instant('COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.VALIDATION.BEGINN_AWJ_NOT_01_01'))
            ]],
            artAufteilung: [this.data.artAufteilung,
                [
                    this.validatorService.required()
                ]]
        });
    }
}
